export default __webpack_public_path__ + "static/media/filter_item.f9576eea.svg";